import { POSQueueOrder } from 'types/pos.interface';

export const getOrderSum = (orders: POSQueueOrder[]) => orders.reduce((acc, order) => acc + order.total, 0);

export const getTotalOrderItems = (
  orders: POSQueueOrder[],
) => orders.reduce((acc, order) => acc + order.lineItemCount, 0);
